module.exports = __webpack_public_path__ + "img/symbol_3.5fac722b.png";